//chapter1
export default {
    id : 10,//chapter number
    title : '10. SBA(Solder Ball Attach) 공정 (4)',//chapter name
    slides : [
        {
            title : 'Intro',
            type : 'intro',
            autoNext : 'N',//Y : yes , N: no
            nextBtn : 'Y',//Y : yes , N: no
            source : 'https://cdn.allwinedu.net/net/contents5/HU12/10/videos/a10.mp4',
        },
        {
            title : 'Today’s Goal',
            type : 'plan',
            autoNext : 'N',//Y : yes , N: no, P : popup
            duration : 20000,// default 20 sec  
            nextBtn : 'Y',//Y : yes , N: no
            body1 : [
                '솔더의 크기 및 피치의 미세화 진행',
                '솔더 볼 접합 관련 불량',
            ],
            body2 : [
                '솔더의 크기 및 피치의 미세화 진행에 대해 설명할 수 있다.',
                '솔더 볼 접합 관련 불량에 대해 설명할 수 있다.'
            ],
            bgm : "plan.mp3"
        },
        {
            title : 'Lesson',
            type : 'lesson',
            autoNext : 'N',//Y : yes , N: no, P: popup
            nextBtn : 'Y',//Y : yes , N: no
            order : null, // if a chapter have multiple lessons, set order please ex)
            source : 'https://cdn.allwinedu.net/net/contents5/HU12/10/videos/10.mp4',
        },
        {
            title : 'Quiz',
            type : 'quiz',
            quiz : [
                {
                    type : 'ox',
                    title : 'Quiz',
                    question : 'IR Reflow 공정은 솔더 볼을 PCB에 접합시킬 때와 부품을 PCB에 실장할 때 사용하는 공정이다.',//html available
                    answer : "1",
                    explain : 'IR Reflow 공정은 솔더가 녹는 고온의 환경을 만들어 PCB에 솔더 볼을 접합하거나 부품을 실장하는 공정이다.'
                },
                {
                    type : 'ox',
                    title : 'Quiz',
                    question : '솔더범프의 피치와 크기는 한계가 있어서 어느 수준을 넘어가면 미세화가 불가능하다.',//html available
                    answer : "2",
                    explain : '마이크로 범프, Cu pillar 등의 기술을 이용해 미세화를 구현하고 있다.'
                },
            ],
            quizMask : "../assets/images/quiz_intro.jpg",//quiz mask bg
            quizMaskStart : "../assets/images/quiz_intro_start.png",//quiz mask bg
            quizIntroText : "../assets/images/quiz_intro_text.png",//quiz mask bg
            bgm : "quiz.mp3"
        },
        {
            title : 'Summary',
            type : 'summary',
            autoNext : 'N',//Y : yes , N: no
            duration : 20000,// default 20 sec  
            nextBtn : 'Y',//Y : yes , N: no
            //download : 'sample.pptx',//data folder
            print : false,// true : show, false: hide
            slides : [
                {
                    body : `<ul>
                        <li>반도체 선폭이 미세화 되면서 솔더의 크기와 피치도 미세화 진행<br>
                        - 솔더 볼 접합<br>
                        - 표준 플립칩 범프<br>
                        - 미세 미치 플립칩 범프 <br>
                        - 플립칩 마이크로 범프 <br>
                        - Cu Pillar 범프<br>
                        - 마이크로 범프 <br>
                        - 범프리스 패드</li>
                    </ul>`
                },
                {
                    body : `<ul>
                        <li>솔더 볼 접합 관련 불량<br>
                        - Missing 솔더 볼<br>
                        - Bridging 솔더 볼<br>
                        - 볼 크기 불량<br>
                        - 볼 손상 불량<br>
                        - 볼 위치 불량</li>
                    </ul>`
                },
            ],
            bgm : "summary.mp3"
        },
        {
            title : 'Outro',
            type : 'outro',
            source : 'https://cdn.allwinedu.net/net/contents5/HU12/10/videos/a10.mp4',
        },
    ]
}